import axios from 'axios';
import { getServerURL } from './urls';
export var sendContactFormEmail = function sendContactFormEmail(params) {
  var businessType = params.businessType,
      businessId = params.businessId,
      locationId = params.locationId,
      name = params.name,
      email = params.email,
      emailSubject = params.emailSubject,
      message = params.message,
      contactOptIn = params.contactOptIn;
  var url = getServerURL();
  var fullUrl = "".concat(url, "businesses/").concat(businessType, "s/").concat(businessId, "/locations/").concat(locationId, "/email/");
  return axios.post(fullUrl, {
    contact_name: name,
    contact_email: email,
    contact_message: message,
    contact_opt_in: contactOptIn,
    email_subject: emailSubject
  });
};
export var searchDomains = function searchDomains(potentialDomain) {
  var headers = {
    'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
  };
  var url = getServerURL();
  return axios.get("".concat(url, "domains/search/details/?domain=").concat(potentialDomain), {
    headers: headers
  });
};